/* global sessionStorage */

import { NEW_USER_SESSION_STORAGE_KEY } from './constants';

export function getNewUserSession() {
  try {
    return JSON.parse(sessionStorage.getItem(NEW_USER_SESSION_STORAGE_KEY));
  } catch (error) {
    return null;
  }
}

export function saveNewUserSession(result) {
  const { user, patient } = result;
  if (!user || !patient) {
    return;
  }
  const { patient: userPatient } = user;
  const session = {
    ...user,
    patient: {
      ...userPatient,
      dependents: {
        nodes: [],
      },
    },
  };
  if (patient.id !== userPatient.id) {
    session.patient.dependents.nodes = [patient];
  }
  try {
    sessionStorage.setItem(NEW_USER_SESSION_STORAGE_KEY, JSON.stringify(session));
  } catch (error) {
    // do nothing
  }
}

export function deleteNewUserSession() {
  sessionStorage.removeItem(NEW_USER_SESSION_STORAGE_KEY);
}
